import styled from "styled-components";
import { Heading, Logo, ButtonSettings, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const PromotionalPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: absolute;
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-color: #000;
    opacity: 0.3;
  }
`;

export const HeadingStyled = styled(Heading)`
  width: 80%;
  margin-bottom: ${props => props.theme.spacing.medium};
`;

export const TextStyled = styled(Text)`
  width: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "74%" : "90%")};
  font-weight: 100;
  ${props =>
    props.showBullet &&
    `
    display: list-item;
    list-style-position: inside;
  `}
`;

export const TextDisclaimerStyled = styled(Text)`
  position: absolute;
  font-weight: 100;
  padding-bottom: inherit;
  bottom: 0;
`;
export const PromotionalContainerStyled = styled.article`
  width: 80%;
  height: 100%;
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 0;
  top: 0;
  padding: 5%;
  padding-left: 8%;
  ${/* background: ${props =>
    `linear-gradient(to ${
      props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"
    }, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%);`}; */ ""};
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  width: 35rem;
  display: inline-block;
  min-width: 11.4vw;
  text-transform: uppercase;
  ${props =>
    props.displayBlock
      ? `display: block`
      : `
      ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "margin-right" : "margin-left"}: ${
          props.theme.spacing.small
        };
  `}
  margin-top: ${props => props.theme.spacing.xsmall};
  &:first-of-type {
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "margin-right" : "margin-left")}: 0;
    margin-top: ${props => props.theme.spacing.small};
  }
  &:last-of-type {
    margin-bottom: ${props => props.theme.spacing.small};
  }
`;

export const LogoContainerStyled = styled.div`
  margin-bottom: ${props => props.theme.spacing.xlarge};
`;

export const LogoStyled = styled(Logo)`
  display: block;
  ${props => props.inlineBlock && `display: inline-block`}
`;

export const SecondaryLogoStyled = styled.img`
  ${props => props.inlineBlock && `display: inline-block`}
  vertical-align: middle;
  margin-top: -25px;
  & + & {
    margin: 0 15px;
  }
`;
